import React from "react";
import "./scrollup.css";

const ScrollUp = () => {

    window.addEventListener("scroll", () => {
        const scrollup = document.querySelector(".scrollup");
        scrollup.classList.toggle("show-scroll", window.scrollY >= 560);
    });

    return (
        <a href="/#" className="scrollup">
            <i className="uil uil-arrow-up scrollup__icon"></i>
        </a>
    );
};

export default ScrollUp;